<template>
  <section id="upskilling-courses" class="hp-section hp-section--compact hp-bento hp-animate hp-animate--delay-1">
    <div class="container">
      <div class="hp-bento__header">
        <div class="hp-bento__hero">
          <h2 class="hp-section__title">Upskill for better job opportunities</h2>
          <p class="hp-section__subtitle">
            Placement-focused programs from leading institutes — banking, finance, AI &amp; more
          </p>
        </div>
        <p class="hp-bento__prompt">
          <span>Explore curated courses 👇</span>
        </p>
      </div>

      <div class="hp-bento__grid">
        <a
          v-for="course in courses"
          :key="course.url"
          :href="course.url"
          class="hp-bento__card"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="hp-bento__image" v-if="course.image">
            <img :src="course.image" :alt="course.name" loading="lazy" />
            <span v-if="course.badge" class="hp-bento__badge">{{ course.badge }}</span>
          </div>
          <div class="hp-bento__body">
            <span v-if="course.category" class="hp-bento__tag">{{ course.category }}</span>
            <h3 class="hp-bento__title">{{ course.name }}</h3>
            <p class="hp-bento__meta">{{ course.institute }}</p>
            <p class="hp-bento__desc" v-if="course.tagline">{{ course.tagline }}</p>
            <ul v-if="course.bullets && course.bullets.length" class="hp-bento__bullets">
              <li v-for="(bullet, idx) in course.bullets" :key="idx">{{ bullet }}</li>
            </ul>
            <p v-if="course.stat" class="hp-bento__stat">
              <span class="hp-bento__stat-icon" aria-hidden="true">✓</span>
              {{ course.stat }}
            </p>
            <span class="hp-btn hp-btn--primary">{{ course.linkLabel || 'Explore' }}</span>
          </div>
        </a>
      </div>

      <p class="hp-bento__trust">
        Partner programs trusted by learners across India
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeTrendingCourses',
  props: {
    courses: { type: Array, default: () => [] },
  },
};
</script>
